export const manifest = {
  screens: {
    scr_a1irht: { name: "Home", route: "/", state: {"screen":"home"}, position: {"x":160,"y":220} },
    scr_r0wfu0: { name: "Explore", route: "/", state: {"screen":"explore"}, position: {"x":1560,"y":220} },
    scr_cvrasm: { name: "Scan", route: "/", state: {"screen":"scan"}, position: {"x":1560,"y":2200} },
    scr_pypd8a: { name: "Store Profile", route: "/", state: {"screen":"storeProfile"}, position: {"x":160,"y":2200} },
    scr_w8px4z: { name: "Check-In Success", route: "/", state: {"screen":"checkInSuccess"}, position: {"x":2960,"y":2200} },
    scr_awp5r5: { name: "Menu", route: "/", state: {"screen":"menu"}, position: {"x":2960,"y":220} },
    scr_67oltq: { name: "Checkout", route: "/", state: {"screen":"checkout"}, position: {"x":160,"y":4180} },
    scr_xchaw9: { name: "Bill Split", route: "/", state: {"screen":"billSplit"}, position: {"x":1560,"y":4180} },
    scr_yzkm6t: { name: "Orders", route: "/", state: {"screen":"orders"}, position: {"x":160,"y":6160} },
    scr_72bkgo: { name: "Order Details", route: "/", state: {"screen":"orderDetails"}, position: {"x":1560,"y":6160} },
    scr_7yr5z3: { name: "Treats (Gifting)", route: "/", state: {"screen":"gifting"}, position: {"x":160,"y":8140} },
    scr_w14fnp: { name: "Gift History", route: "/", state: {"screen":"giftHistory"}, position: {"x":1560,"y":8140} },
    scr_1047sf: { name: "Gift Redeem", route: "/", state: {"screen":"giftRedeem"}, position: {"x":2960,"y":8140} },
    scr_63nxc5: { name: "Drops", route: "/", state: {"screen":"drops"}, position: {"x":160,"y":10120} },
    scr_oiog1k: { name: "Drop Detail", route: "/", state: {"screen":"dropDetail"}, position: {"x":1560,"y":10120} },
    scr_8m4877: { name: "Drop Unlocked", route: "/", state: {"screen":"dropUnlocked"}, position: {"x":2960,"y":10120} },
    scr_9u6pjn: { name: "Make a Plan", route: "/", state: {"screen":"plan"}, position: {"x":160,"y":12100} },
    scr_7a56yi: { name: "Host a Gathering", route: "/", state: {"screen":"hostGathering"}, position: {"x":1560,"y":12100} },
    scr_f4r0u9: { name: "Profile", route: "/", state: {"screen":"profile"}, position: {"x":160,"y":14080} },
    scr_qqhq23: { name: "Favorite Places", route: "/", state: {"screen":"favoritePlaces"}, position: {"x":1560,"y":14080} },
    scr_rnkmf3: { name: "List Detail", route: "/", state: {"screen":"listDetail"}, position: {"x":2960,"y":14080} },
    scr_a4l6fh: { name: "Mix & Share", route: "/", state: {"screen":"mixShare"}, position: {"x":2960,"y":12100} },
  },
  sections: {
    sec_jn8lv2: { name: "Home & Navigation", x: 0, y: 0, width: 4320, height: 1180 },
    sec_739lp2: { name: "Location & Check-In", x: 0, y: 1980, width: 4320, height: 1180 },
    sec_tzzeba: { name: "Checkout & Payments", x: 0, y: 3960, width: 2920, height: 1180 },
    sec_wsa0u3: { name: "Order Management", x: 0, y: 5940, width: 2920, height: 1180 },
    sec_4kgvr7: { name: "Gifting", x: 0, y: 7920, width: 4320, height: 1180 },
    sec_xb92fn: { name: "Limited Drops", x: 0, y: 9900, width: 4320, height: 1180 },
    sec_satibd: { name: "Social Planning", x: 0, y: 11880, width: 4320, height: 1180 },
    sec_kjx5sh: { name: "User Profile", x: 0, y: 13860, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_jn8lv2", children: [
      { kind: "screen", id: "scr_a1irht" },
      { kind: "screen", id: "scr_r0wfu0" },
      { kind: "screen", id: "scr_awp5r5" },
    ] },
    { kind: "section", id: "sec_739lp2", children: [
      { kind: "screen", id: "scr_pypd8a" },
      { kind: "screen", id: "scr_cvrasm" },
      { kind: "screen", id: "scr_w8px4z" },
    ] },
    { kind: "section", id: "sec_tzzeba", children: [
      { kind: "screen", id: "scr_67oltq" },
      { kind: "screen", id: "scr_xchaw9" },
    ] },
    { kind: "section", id: "sec_wsa0u3", children: [
      { kind: "screen", id: "scr_yzkm6t" },
      { kind: "screen", id: "scr_72bkgo" },
    ] },
    { kind: "section", id: "sec_4kgvr7", children: [
      { kind: "screen", id: "scr_7yr5z3" },
      { kind: "screen", id: "scr_w14fnp" },
      { kind: "screen", id: "scr_1047sf" },
    ] },
    { kind: "section", id: "sec_xb92fn", children: [
      { kind: "screen", id: "scr_63nxc5" },
      { kind: "screen", id: "scr_oiog1k" },
      { kind: "screen", id: "scr_8m4877" },
    ] },
    { kind: "section", id: "sec_satibd", children: [
      { kind: "screen", id: "scr_9u6pjn" },
      { kind: "screen", id: "scr_7a56yi" },
      { kind: "screen", id: "scr_a4l6fh" },
    ] },
    { kind: "section", id: "sec_kjx5sh", children: [
      { kind: "screen", id: "scr_f4r0u9" },
      { kind: "screen", id: "scr_qqhq23" },
      { kind: "screen", id: "scr_rnkmf3" },
    ] },
  ],
}
